import { render } from "@/components/pages/individualWorkSupport/requirement079/Requirement079.html?vue&type=template&id=b2b254be&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement079/Requirement079.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement079/Requirement079.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement079/Requirement079.scss?vue&type=style&index=0&id=b2b254be&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b254be"]])

export default __exports__